const systemMessage = {
  namespaced: true,
  state: () => ({
    Message: "",
    SubMessage: "",
    ModalMessage: "",
    SettingsModalFlag: false,
    visible: false,
  }),
  getters: {
    getMessage: (state) => {
      return state.Message;
    },
    getModalSubMessage: (state) => {
      return state.SubMessage;
    },
    getModalMessage: (state) => {
      return state.ModalMessage;
    },
    getSettingsModalFlag: (state) => {
      return state.SettingsModalFlag;
    },
  },
  actions: {
    setMessage({ commit }, params) {
      commit("SET_MESSAGE", params.message);
    },
    setModalMessage({ commit }, params) {
      commit("SET_MODAL_MESSAGE", params.message);
      commit("SET_SUBMESSAGE", params.subMessage ?? "");
    },
  },
  mutations: {
    SET_MESSAGE: (state, message) => {
      state.Message = message;
    },
    SET_SUBMESSAGE: (state, subMessage) => {
      state.SubMessage = subMessage;
    },
    SET_MODAL_MESSAGE: (state, message) => {
      state.ModalMessage = message ? message : "";
    },
    SET_SETTINGS_MODAL_FLAG: (state, flag) => {
      state.SettingsModalFlag = flag ? flag : false;
    },
    SET_VISIBLE: (state, data) => {
      state.visible = data;
    },
  },
};

export default systemMessage;
